import {css} from 'styled-components';

export default css `
  background-color: #66787b;
  color: white;

  // Browser-compatible centering. See "Both/unknown size" at:
  // https://css-tricks.com/centering-css-complete-guide/
  position: relative;

  > .icon {
    // Child element side of browser-compatible centering; see reference above.
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 60%;
  }

  > svg {
    // currentColor is supported since IE9, but degrade gracefully anyway.
    fill: white;
    fill: currentColor;
  }

  // size modifiers

  &.small {
    height: 28px;
    width: 28px;
  }

  &.medium {
    height: 34px;
    width: 34px;
  }

  &.large {
    height: 40px;
    width: 40px;
  }

  &.fit {
    height: 100%;
    width: 100%;
  }

  // site modifiers

  &.facebook {
    background-color: #3b5998;
  }

  &.linkedin {
    background-color: #0077b5;
  }

  &.pinterest {
    background-color: #bd081c;
  }

  &.tumblr {
    background-color: #35465c;
  }

  &.twitter {
    background-color: #1da1f2;
  }

  &.instagram {
    background-color: #e1306c;
  }

  // appearance modifiers

  &.round {
    border-radius: 50%;
  }

  &.square {
    border-radius: 15%;
  }

  &.clear {
    background-color: transparent;
    color: currentColor;
  }

  // visual design special cases

  // The share icon is visually balanced to the right. Shifting it left in the
  // circle keeps the distance from the 3 outer points of the icon evenly
  // spaced from the circle's edge, which makes it appear centered.
  &.share.round > .icon {
    transform: translate(-58%, -50%);
  }

  // Email round needs to be lightened up due to the envelope icon's heavy
  // visual weight overwhelming the round background (which has more negative
  // space in the corners than the square style).
  &.email.round > .icon {
    width: 55%;
    height: 55%;
  }
`
